import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAllCompanyInfo } from '../../../util/DatabaseUtil';
import { CircularProgress } from '@mui/material';

const Business = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        setLoading(true);
        const response = await getAllCompanyInfo();
        setCompanies(response?.businesses || []);
      } catch (error) {
        console.error('Error fetching company info:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, []);

  return (
    <div className="p-6 min-h-fit">
      {loading ? (
        <div className="flex justify-center items-center h-40">
          <CircularProgress size={50} color="primary" />
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {companies.length > 0 ? (
            companies
              .filter((company) => company.totalReviews > 0) // Filter companies with reviews
              .map((company, index) => {
                let ratingOutOf10 = (company.averageRating / 5) * 10;
                if (company.averageRating > 5 || company.averageRating < 0) {
                  ratingOutOf10 = null;
                }

                return (
                  <Link
                    key={index}
                    to={`/business/${company._id}`}
                    className="bg-[#2d2d2d] p-6 rounded-xl shadow-lg cursor-pointer hover:shadow-2xl transition-transform transform 
                    hover:-translate-y-2 duration-300 ease-in-out block"
                  >
                    <h3 className="text-xl font-semibold text-white mb-3 capitalize">
                      {company.name}
                    </h3>

                    <div className="flex flex-wrap gap-2">
                      {company.category?.map((cat, idx) => (
                        <span
                          key={idx}
                          className="bg-[#F2994A] text-white text-xs font-semibold px-3 py-1 capitalize rounded-full"
                        >
                          {cat}
                        </span>
                      ))}
                    </div>

                    <div className="mt-4 flex flex-col items-center">
                      {ratingOutOf10 !== null ? (
                        <div className="relative w-20 h-20 flex items-center justify-center">
                          <CircularProgress
                            variant="determinate"
                            value={(ratingOutOf10 / 10) * 100}
                            size={80}
                            thickness={5}
                            sx={{ color: '#F2994A' }}
                          />
                          <div className="absolute text-white text-sm font-semibold">
                            {ratingOutOf10.toFixed(1)}/10
                          </div>
                        </div>
                      ) : (
                        <span className="text-gray-400 text-sm">N/A</span>
                      )}
                      <span className="text-gray-400 text-sm mt-1">
                        ({company.totalReviews} reviews)
                      </span>
                    </div>
                  </Link>
                );
              })
          ) : (
            <p className="text-gray-400 text-center text-lg col-span-full">
              No company data available.
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default Business;
